import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    selector: 'resourceGrade',
    templateUrl: './AppViews/ResourceGrade/resourceGrade.html'
})

export class ResourceGradeComponent implements OnInit {
    public constants: Constants;
    public resourceGrade: any[] = [];
    public teams: any[] = [];
    public grades: any = [];
    public Search: any = "";
    public addResourceGradeData: any = { addTeam: "", addGradeName: "" };
    public editResourceGradeData: any = { editTeam: "" };
    public isAdd: boolean = true;
    public filterTeamName: any = "";
    userDetail: any;
    active = true;
    public existsGradeName: boolean = false;
    public isFormSubmitted: boolean = false;
    public showLoader = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
        this.existsGradeName = false;
    }

    ngOnInit() {

        this.getTeam();
        this.getResourceGrade();
        this.getGrade();
    }

    ExportItems() {
        ExportToExcel(this.resourceGrade, "ResourceGrade",
            ["GradeName", "Name"],
            ["Grade Level", "Name"]);
    }

    ngAfterViewInit() {

        $("#show-grade-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public AddResourceGradeFormLoad() {
        $('#btnAddResourceGradeForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public getGrade() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["Grade"] }).subscribe(
            data => {
                this.grades = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getTeam() {
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetTeam', { "Team_Id": 0 }).subscribe(
            data => {
                this.teams = data["Team"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getResourceGrade() {
        this.showLoader = true;
        this._httpService.ajaxPost('ResourceGrade/GetResourceGrade', { "GradeId": 0, "TeamId": 0 }).subscribe(
            data => {
                this.resourceGrade = data["ResourceGradeList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this.showLoader = false;
            }
        );
    }
    public clearFilter() {

        this.Search = "";
        this.filterTeamName = "";
    }

    public CancelAddResourceGrade() {
        this.existsGradeName = false;
        this.newForm();
        $('#addResourceGrade').modal('hide');
        this.isAdd = true;
        this.addResourceGradeData = { addTeam: "" };
    }

    public CancelEditResourceGrade() {
        this.existsGradeName = false;
        this.editResourceGradeData = {};
        this.newForm();
        $('#editResourceGrade').modal('hide');
        this.isAdd = true;
    }
    public AddResourceGrade(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsGradeName = false;
            this.resourceGrade.forEach(element => {
                if (element.Attribute_Value == this.addResourceGradeData.addGradeName && element.TeamId == this.addResourceGradeData.addTeam) {
                    this.existsGradeName = true;
                }
            });
            if (!this.existsGradeName) {
                let objItem: any = {};
                objItem.ResourceGradeId = 0;
                objItem.GradeId = this.addResourceGradeData.addGradeName;
                objItem.TeamId = this.addResourceGradeData.addTeam;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.UpdatedBy = this.userDetail.SiteUserId;
                this.addEditResourceGrade(objItem);
                $('#addResourceGrade').modal('hide');
                this.addResourceGradeData = { addTeam: "" };
                this.newForm();
                this.isAdd = true;
                this.existsGradeName = false;
            }
        }
    }

    public EditResourceGrade(item: any) {
        $('#btnEditResourceGradeForm').trigger('click');
        this.isAdd = false;
        this.EditResourceGradeChange(item.GradeId, item.TeamId);
    }

    public EditResourceGradeChange(itemId, teamId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.resourceGrade.filter((resourceGrade) => resourceGrade.GradeId == itemId && resourceGrade.TeamId == teamId)[0]));
        this.editResourceGradeData.editResourceGradeId = objItem.ResourceGradeId
        this.editResourceGradeData.editGradeId = objItem.Attribute_Value;
        this.editResourceGradeData.editGradeName = objItem.GradeName;
        this.editResourceGradeData.editTeamName = objItem.TeamId;
    }

    public UpdateResourceGrade(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsGradeName = false;
            this.resourceGrade.forEach(element => {
                // if (element.ResourceGradeId != this.editResourceGradeData.editResourceGradeId && element.TeamId == this.editResourceGradeData.editTeamName)
                if(element.ResourceGradeId != this.editResourceGradeData.editResourceGradeId &&  element.Attribute_Value == this.editResourceGradeData.editGradeId &&   element.TeamId == this.editResourceGradeData.editTeamName) {
                    this.existsGradeName = true;
                }
            });
            if (!this.existsGradeName) {
                let objItem: any = {};
                objItem.ResourceGradeId = this.editResourceGradeData.editResourceGradeId;
                objItem.GradeId = this.editResourceGradeData.editGradeId;
                objItem.TeamId = this.editResourceGradeData.editTeamName;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                objItem.UpdatedBy = this.userDetail.SiteUserId;
                this.addEditResourceGrade(objItem);
                $('#editResourceGrade').modal('hide');
                this.editResourceGradeData = {};
                this.newForm();
                this.existsGradeName = false;
                this.isAdd = true;
            }
        }
    }

    addEditResourceGrade(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('ResourceGrade/AddUpdateResourceGrade', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getResourceGrade();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);


            },
            () => {
                this.showLoader = false;
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/ResourceGrade/ResourceGrade.component.ts
 **/